class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.predictive-search');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.predictiveSearchForm = this.querySelector('form');

    this.input.form.addEventListener('reset', this.onFormReset.bind(this));
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hiddenReset');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hiddenReset');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hiddenReset');
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    
    this.toggleResetButton();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.setAttribute("loading", !0);

    this.getSearchResults(searchTerm);
  }
  
  onFormReset(event) {
    this.close();
    this.input.value = '';
    this.toggleResetButton();
  }

  getSearchResults(searchTerm) {
    var fetch_root = '/search',
      search_url = this.predictiveSearchForm.getAttribute('action'); /* to ensure language/location is in root url, e.g. /en-uk/search */
    if(search_url.includes('/search')) {
      fetch_root = search_url.replace('/search/', '/search'); /* just in case */
    }
    fetch(`${fetch_root}/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        this.removeAttribute("loading");
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.setAttribute("open", !0);
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.removeAttribute("open");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

$(document).ready( function() {
    
  function load_search_bar_suggestions($predictive_search, $predictive_search_suggestions) {
    if($predictive_search.length > 0) {
      if($predictive_search_suggestions.hasClass('loaded')) {
        $predictive_search.removeAttr('loading');
        return;
      }
      var source = '/search?view=suggestions',
        search_root = $predictive_search.find('form').attr('action');
      if(search_root.includes('/search')) { /* to ensure language/location is in root url, e.g. /en-uk/search */
        source = search_root + '?view=suggestions';
      }
      $predictive_search_suggestions.load(source, function() {
        $predictive_search.removeAttr('loading');
        $predictive_search_suggestions.addClass('loaded');
      });
    }
  }
  
  $('.open-searchBar').on('click', function(e) {
    e.preventDefault();
    $('body').addClass('searchBar-open');
    var $search_bar_predictive_search = $('#searchBar').find('predictive-search'),
      $search_bar_predictive_search_suggestions = $search_bar_predictive_search.find('.predictive-search'),
      $search_bar_search_input = $search_bar_predictive_search.find('.search-form__input');
    $search_bar_predictive_search.attr('loading', true);
    setTimeout( function() {
      $search_bar_search_input.focus();
      $search_bar_predictive_search_suggestions.show();
    }, 400);
    setTimeout( function() {
      load_search_bar_suggestions($search_bar_predictive_search, $search_bar_predictive_search_suggestions);
    }, 800);
    var offset_top = $search_bar_search_input.offset().top + $search_bar_search_input.outerHeight(),
      max_height = $(window).height() - offset_top;
    $search_bar_predictive_search_suggestions.css('max-height',max_height);
  });
  $('.close-searchBar').on('click', function() {
    $('body').removeClass('searchBar-open');
  });

  $('.mobile-menu__actions-link[for="mobile-menu-search"]').on('click', function() {
    var $mm_bar_predictive_search = $('.mobile-menu').find('predictive-search');
    var $mm_predictive_search_suggestions = $mm_bar_predictive_search.find('.predictive-search');
    setTimeout( function() {
      $('.mobile-menu .search-form__input').focus();
      load_search_bar_suggestions($mm_bar_predictive_search, $mm_predictive_search_suggestions);
    }, 500);
  });
  
}); /* End document.ready */